
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const FibonacciScale = () => {
  const scaleItems = [
    { points: 1, days: 0.5, description: "Trivial change" },
    { points: 2, days: 1, description: "Simple task" },
    { points: 3, days: 2, description: "Small feature" },
    { points: 5, days: 3, description: "Medium feature" },
    { points: 8, days: 5, description: "Complex feature" },
    { points: 13, days: 8, description: "Very complex feature" },
    { points: 21, days: 11, description: "Extremely complex feature" }
  ];

  return (
    <Card className="bg-white dark:bg-gray-900 border-blue-100 dark:border-gray-800">
      <CardHeader className="border-b border-blue-100 dark:border-gray-800 pb-3">
        <CardTitle className="text-lg text-blue-700 dark:text-gray-300">
          Fibonacci Story Points Scale
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-4">
        <div className="space-y-2">
          {scaleItems.map((item, index) => (
            <div key={index} className="flex justify-between items-center py-1 border-b border-blue-50 dark:border-gray-800 last:border-0">
              <div className="flex items-center">
                <div className="h-6 w-6 rounded-full bg-blue-600 dark:bg-blue-800 text-white flex items-center justify-center text-xs mr-2">
                  {item.points}
                </div>
                <span className="text-gray-700 dark:text-gray-300 text-sm">
                  {item.description}
                </span>
              </div>
              <div className="text-sm font-medium text-blue-800 dark:text-blue-400">
                {item.days} {item.days === 1 ? 'day' : 'days'}
              </div>
            </div>
          ))}
        </div>
        <div className="mt-3 text-xs text-gray-500 dark:text-gray-400">
          <p>- Development time is approx. 40% of the total effort</p>
          <p>- The rest includes discovery, design, testing, and documentation</p>
        </div>
      </CardContent>
    </Card>
  );
};
